import React, { CSSProperties, FC, ReactNode } from 'react'

import styled from 'styled-components'

const Item = styled.div`
  display: flex;
  flex-basis: 33%;
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
`

export const ItemPanel: FC<{
  start?: ReactNode
  end?: ReactNode
  style?: CSSProperties
}> = ({ start, end, style }) => {
  return (
    <Container style={style}>
      <Item style={{ justifyContent: 'flex-start' }}>{start}</Item>
      <Item style={{ justifyContent: 'flex-end' }}>{end}</Item>
    </Container>
  )
}
